import React from 'react';
import { noop } from 'lodash-es';
import { styled } from '@components-shared/src/stitches';
import { useAudioController } from '@store/audio/AudioController';
import { useAudioPosition } from '@store/audio/AudioPosition';

const MINIMZED_BOX_SHADOW = '-1340px -1341px 0 1340px #000, -1340px -1337px 0 1340px #EB5CBB';

export const Timeline = () => {
  const { duration } = useAudioController();
  const { position } = useAudioPosition();
  return (
    <MinimizedInput type="range" step={1} min={0} value={position} max={duration} onChange={noop} />
  );
};

const MinimizedInput = styled('input', {
  WebkitAppearance: 'none',
  cursor: 'pointer',
  overflow: 'hidden',
  width: '100%',
  transition: 'all 0.2s',
  background: '$neutral600',
  '&::-webkit-slider-runnable-track': {
    height: '2px',
    background: '$neutral600',
  },
  '&::-moz-range-track': {
    height: '2px',
    background: '$neutral600',
  },
  '&::-webkit-slider-thumb': {
    WebkitAppearance: 'none',
    backgroundColor: '$fuchsia500',
    boxShadow: MINIMZED_BOX_SHADOW,
    height: '1px',
    width: '1px',
    transition: 'all 0.2s',
  },

  '&::-moz-range-thumb': {
    backgroundColor: '$fuchsia500',
    border: 'none',
    height: '1px',
    width: '1px',
    transition: 'all 0.2s',
  },
  '&::-moz-range-progress': {
    background: '$fuchsia500',
  },
});
